
import { destroy, get, getOne, post, put } from "../apis/httpClient"

export const pagingRecruitment=(params)=>get('/api/v1/recruitment/paging',params)
export const detailRecruitment=(query)=>getOne(`/api/v1/recruitment/detail/${query}`)
export const updateRecruitment=(body)=>put(`/api/v1/recruitment/update`,body)
export const createRecruitment=(body)=>post(`/api/v1/recruitment/create`,body)
export const deleteRecruitment=(body)=>destroy(`/api/v1/recruitment/delete`,body)
export const listRecruitment=()=>get(`/api/v1/recruitment/listAll`)
